<mat-nav-list>
    <ng-container *ngFor="let section of filteredSections">
        <div class="custom-section">
            <!-- HEADER SEZIONE -->
            <button type="button" class="section-title" (click)="toggleSection(section.key)" [attr.aria-expanded]="openSections[section.key]" [attr.aria-controls]="'sec-' + section.key" [id]="'btn-' + section.key">
          <img src="assets/images/logoQ.png" alt="logo" width="20" style="margin-right: 8px;" />
          <span>{{ section.title }}</span>
  
          <!-- Chevron con Material Icons -->
          <mat-icon class="chev" *ngIf="!openSections[section.key]" aria-hidden="true">chevron_right</mat-icon>
          <mat-icon class="chev" *ngIf="openSections[section.key]" aria-hidden="true">expand_more</mat-icon>
        </button>

            <!-- CONTENUTO COLLASSABILE -->
            <div *ngIf="openSections[section.key]" [id]="'sec-' + section.key" [attr.aria-labelledby]="'btn-' + section.key">
                <a *ngFor="let route of section.routes" mat-list-item [routerLink]="route.path" routerLinkActive="mat-mdc-list-item-active">
                    <div class="mat-mdc-list-item-content ms-3">
                        <!-- Icona circolare Material -->
                        <span class="mat-mdc-list-item-icon">
                <mat-icon class="circled" aria-hidden="true">{{ route.icon }}</mat-icon>
              </span>

                        <span class="mat-mdc-list-item-text" matTooltip="{{route.mouseOver}}">{{ route.label }}</span>
                    </div>
                </a>
            </div>
        </div>
    </ng-container>
</mat-nav-list>